<template>
<div>
    <v-autocomplete 
        v-if="is_settings"
        :items="billing_customers" 
        item-text="name" 
        item-value="id" 
        :placeholder="customer_label || title" 
        :label="customer_label || title" 
        v-model="val_customer"
        :disabled="disabled"
        :required="required||false"
        :rules="(required ? [(v) => !!v || customer_label+' is required'] : undefined)"
        :clearable="(clearable == false ? false : true)"
        :multiple="multiple"
        :chips="multiple"
        :small-chips="multiple"
        :deletable-chips="multiple"
        hide-details>
    ></v-autocomplete>
    <v-autocomplete 
        v-if="is_settings"
        :items="billing_contracts" 
        item-text="title"
        item-value="id" 
        :placeholder="contract_label || title" 
        :label="contract_label || title" 
        v-model="val_contract"
        :disabled="disabled"
        :required="required||false"
        :rules="(required ? [(v) => !!v || contract_label+' is required'] : undefined)"
        :clearable="(clearable == false ? false : true)"
        :multiple="multiple"
        :chips="multiple"
        :small-chips="multiple"
        :deletable-chips="multiple"
        hide-details>
    ></v-autocomplete>
  </div>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';
import Vue from 'vue';
import SettingsModel from '@/models/settings.js';
import { utimesSync } from 'fs';
import datelib from '@/lib/date.js';


export default {
  mixins: [EventMixin],
  props: [
    'value',
    'customer_name',
    'customer_label',
    'contract_name',
    'contract_label',
    'title',
    'required',
    "disabled", 
    "clearable",
    "multiple",
    "show_all_contracts",
    "show_last_billed"
  ],
  data () {
    return {
        customers: [],
        contracts: []
    }
  },
  methods: {
    update_customer_data () {
      var url = "content_list/" + this.customer_list_id;
      var self = this;
      Vue.http.get(url).then((response) => {
        self.customers = response.body;
        self.update_contract_data();
      }, (response) => {
      });
    },
    update_contract_data () {
      var url = "content_list/" + this.contract_list_id;
      var self = this;
      var unparsed_contracts = [];
      Vue.http.get(url).then((response) => {
        self.contracts = response.body;
      }, (response) => {
      });
    },

  },
  computed: {
    is_settings() {
      if (this.settings.length > 0) {
        this.update_customer_data();
        return true;
      }
      return false;
    },
    settings () {
      return SettingsModel.list("billing_config");
    },
    customer_list_id() {
      return this.settings[0].value.customers_list_id;
    },
    contract_list_id() {
      return this.settings[0].value.contracts_list_id;
    },
    billing_customers () {
        return this.customers;
    },
    billing_contracts () {
        var ret = [];
        var self = this;
        _.each(self.contracts, function(item) {
          if (self.$props.show_last_billed) {
            if (typeof(item.last_billed) != undefined) {
              if (typeof(item.date_added) == undefined) {
                item.date_added = false;
              }
              if (item.date_added) {
              } else {
                  item.title += " (" +  datelib.format_date(item.last_billed) + ")";
                  item.date_added = true;
              }
            }
          }
          if (self.$props.show_all_contracts && self.val_customer == "") {
              ret.push(item);
          } else {
              if (item.customer.id == self.val_customer) {
                ret.push(item);
              }
          }
        })
        return ret;
    },
    val_customer: {
      get () {
        return _.get(this.value, this.customer_name) || "";
      },
      set (val_customer) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.customer_name, val_customer);
        this.$emit("input", value);
      }
    },
    val_contract: {
      get () {
        return _.get(this.value, this.contract_name) || "";
      },
      set (val_contract) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.contract_name, val_contract);
        this.$emit("input", value);
      }
    },
  }
}
</script>
